var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('header-bar',{attrs:{"showMenu":"","showLogo":""}}):_vm._e(),_c('h2',{staticClass:"message"},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.info.icon))]),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.info.message)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }